import { useMutation, useSuspenseQuery } from '@tanstack/react-query';

import { getCourseImage } from '@/_prep-portal/courses/api/shared';
import { apiClient } from '@/_services';

import type { PurchasedPracticeExamSchema } from '../../@shared/practice-exam-schema';

export const useGetPurchasedPracticeExams = (userId: string) =>
  useSuspenseQuery<
    { status: string; data: { assessment: PurchasedPracticeExamSchema }[] },
    unknown,
    PurchasedPracticeExamSchema[]
  >({
    queryKey: ['PURCHASED_PRACTICE_EXAMS', userId],
    queryFn: async () => apiClient.request({ endpoint: `/user/${userId}/assessment-enrollment/list/` }),
    select: (data): PurchasedPracticeExamSchema[] => {
      return data.data.map((item) => ({
        ...item.assessment,
        image_url: item.assessment?.image_url ?? getCourseImage(item.assessment.course_name),
      }));
    },
  });

export const useGetPurchasedPracticeExamsMutation = () =>
  useMutation({
    mutationFn: async (userAssessmentId: number | string) =>
      apiClient.request({ endpoint: `/prep-assessment-details/${userAssessmentId}/` }),
  });
